import config from 'config'
import Layout from 'containers/Layout'
import * as React from 'react'
import styled from 'styled-components'
import Container from 'theme/atoms/Container'
import Seo from 'theme/atoms/SEO'
import WishlistItems from './WishlistItems'
import withTranslations from './withTranslations'

type Props = {
  location: {
    origin: string
    pathname: string
  }
}
//wdv-2775-merkliste-implementierung-des-tracking
export default withTranslations(function Wishlist(props: Props) {
  return (
    <Layout>
      <Seo
        canonicalUrl={`${config.baseUrl}${props.location.pathname}`}
        location={props.location}
        // title={t.asText(false, 'seo_title')}
        title=""
        description=""
        type="website"
        seoNoIndex={true}
        seoNoFollow={true}
      />
      <Container>
        <Wrapper data-cy-ctx="templates/Wishlist">
          <WishlistItems />
        </Wrapper>
      </Container>
    </Layout>
  )
})

const Wrapper = styled.div``
